const icons = {
  iconfont: 'mdi',
};

export default icons;
